"use strict";

var SignalStore = require("app/shared/stores/signal-store");
var SignalActions = require("app/shared/actions/signal-actions");

var Signal = React.createClass({
  mixins: [Reflux.ListenerMixin],
  getInitialState: function(){
    return SignalStore.state;
  },

  componentDidMount: function(){
    this.listenTo(SignalStore, this.setState);
  },

  render: function(){
    var className = `col-md-6 col-md-offset-3 alert alert-fixed zi-2000 alert-${this.state.type}`

    if(this.state.open == true) {
      className += " alert-open";
    } else if (this.state.open == false) {
      className += " alert-close";
    }

    if(this.state.instant) {
      className += " alert-instant";
    }

    return (
      <div className={className}>
        <button onClick={SignalActions.instantHide} type="button" className="close" aria-label="close">
          <span aria-hidden="true" className="custom-glyphicon icon-close"></span>
        </button>
        <span dangerouslySetInnerHTML={ { __html: this.getDecodedMessage() } } />
      </div>
    );
  },

  getDecodedMessage: function() {
    var textArea = document.createElement("textarea");
    textArea.innerHTML = this.state.message;
    return textArea.value;
  }
});

module.exports = Signal;



// WEBPACK FOOTER //
// ./app/shared/components/Signal/signal.jsx